import React from "react";
import { Navigate, useParams } from "react-router-dom";

type LegacyCampaignRedirectProps = {
  /** Path appended after the campaign id, e.g. "/edit". */
  suffix?: string;
};

/**
 * Campaign pages used to live at "/campaigns/view/:id" and
 * "/campaigns/edit/:id". They now nest under the campaign itself
 * ("/campaigns/:id" and "/campaigns/:id/edit"), so the old paths stay around
 * as redirects: bookmarks, shared links and already-open tabs keep working.
 */
const LegacyCampaignRedirect: React.FC<LegacyCampaignRedirectProps> = ({
  suffix = "",
}) => {
  const { campaignId } = useParams<{ campaignId: string }>();

  if (!campaignId) {
    return <Navigate to="/campaigns" replace />;
  }

  return <Navigate to={`/campaigns/${campaignId}${suffix}`} replace />;
};

export default LegacyCampaignRedirect;
